import React, { createContext } from 'react'
import { useQuery } from '@apollo/client'
import { CONTACT_QUERY } from '../graphql/Contact'
import CentredLoader from '../components/CentredLoader'
import { LEGAL_FORMALITIES_QUERY } from '../graphql/LegalFormalities'
import { LegalFormalityType } from '../types'

export const LegalFormalitiesContext = createContext({} as any)

interface Iprops {
  contactId: number
  children: any
}
const LegalFormalitiesContextProvider = (props: Iprops) => {
  const { contactId } = props
  const { data, loading } = useQuery(LEGAL_FORMALITIES_QUERY, {
    variables: { contactId: contactId },
  })

  if (loading) {
    return <CentredLoader />
  }

  const formalities: [LegalFormalityType] = data.legalFormalities

  return (
    <LegalFormalitiesContext.Provider value={{ legalFormalities: formalities }}>
      {props.children}
    </LegalFormalitiesContext.Provider>
  )
}

export default LegalFormalitiesContextProvider
